export type GoalStatus = "onTrack" | "behindPlan" | "atRisk";

/**
 * Cutoffs of the backend's ConfigurationValues.INVESTMENT_GOAL; the API
 * itself only reports isOnTrack (the first cutoff).
 */
const ON_TRACK_CUTOFF = -0.1;
const AT_RISK_CUTOFF = -0.2;

export const getGoalStatus = (percentDeviation?: number): GoalStatus => {
  if (percentDeviation === undefined || percentDeviation >= ON_TRACK_CUTOFF) {
    return "onTrack";
  }
  return percentDeviation >= AT_RISK_CUTOFF ? "behindPlan" : "atRisk";
};
